import cx from 'classnames';
import { FC, ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';

import {
  getCatalogFiltersRequested,
  getCatalogVacanciesRequested,
} from '../../redux/actions/admin-page';
import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import { Container } from '../UI/Container';
import { VacanciesCardsList } from './VacanciesCardsList';
import classes from './VacanciesCatalog.module.scss';
import { VacanciesCatalogProps } from './VacanciesCatalog.types';
import { VacanciesFilter } from './VacanciesFilter';

export const VacanciesCatalog: FC<VacanciesCatalogProps> = ({
  className,
}): ReactElement => {
  const isMobile = useMediaQuery(mediaQueries.mobile);
  const { search } = useLocation();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    searchParams.delete('page');
    dispatch(
      getCatalogFiltersRequested({ search: `?${searchParams.toString()}` }),
    );
    dispatch(getCatalogVacanciesRequested({ search }));
  }, [search]);

  return (
    <div className={cx(classes['vacancies-catalog'], className)}>
      <Container className={classes['vacancies-catalog__container']}>
        <div className={classes['vacancies-catalog__body']}>
          <div className={classes['vacancies-catalog__grid']}>
            {!isMobile && (
              <div
                className={cx(
                  classes['vacancies-catalog__grid-item'],
                  classes['vacancies-catalog__grid-item--filter'],
                )}
              >
                <VacanciesFilter />
              </div>
            )}

            <VacanciesCardsList />
          </div>
        </div>
      </Container>
    </div>
  );
};
